/**
 * Full-frame confetti flipbook: Figma "Confetti 1" component set (Variant=1–20),
 * AI Scheduling Assistant – Email Scheduler file. Each asset is 1400×1080 @1x PNG.
 */
import confettiFrame01 from './frames/confetti-frame-01.png'
import confettiFrame02 from './frames/confetti-frame-02.png'
import confettiFrame03 from './frames/confetti-frame-03.png'
import confettiFrame04 from './frames/confetti-frame-04.png'
import confettiFrame05 from './frames/confetti-frame-05.png'
import confettiFrame06 from './frames/confetti-frame-06.png'
import confettiFrame07 from './frames/confetti-frame-07.png'
import confettiFrame08 from './frames/confetti-frame-08.png'
import confettiFrame09 from './frames/confetti-frame-09.png'
import confettiFrame10 from './frames/confetti-frame-10.png'
import confettiFrame11 from './frames/confetti-frame-11.png'
import confettiFrame12 from './frames/confetti-frame-12.png'
import confettiFrame13 from './frames/confetti-frame-13.png'
import confettiFrame14 from './frames/confetti-frame-14.png'
import confettiFrame15 from './frames/confetti-frame-15.png'
import confettiFrame16 from './frames/confetti-frame-16.png'
import confettiFrame17 from './frames/confetti-frame-17.png'
import confettiFrame18 from './frames/confetti-frame-18.png'
import confettiFrame19 from './frames/confetti-frame-19.png'
import confettiFrame20 from './frames/confetti-frame-20.png'

/** In playback order (designed fall sequence). Stable `id` values for list keys. */
export const confettiPlaybackFrames = [
  { id: 'confetti-frame-01', src: confettiFrame01 },
  { id: 'confetti-frame-02', src: confettiFrame02 },
  { id: 'confetti-frame-03', src: confettiFrame03 },
  { id: 'confetti-frame-04', src: confettiFrame04 },
  { id: 'confetti-frame-05', src: confettiFrame05 },
  { id: 'confetti-frame-06', src: confettiFrame06 },
  { id: 'confetti-frame-07', src: confettiFrame07 },
  { id: 'confetti-frame-08', src: confettiFrame08 },
  { id: 'confetti-frame-09', src: confettiFrame09 },
  { id: 'confetti-frame-10', src: confettiFrame10 },
  { id: 'confetti-frame-11', src: confettiFrame11 },
  { id: 'confetti-frame-12', src: confettiFrame12 },
  { id: 'confetti-frame-13', src: confettiFrame13 },
  { id: 'confetti-frame-14', src: confettiFrame14 },
  { id: 'confetti-frame-15', src: confettiFrame15 },
  { id: 'confetti-frame-16', src: confettiFrame16 },
  { id: 'confetti-frame-17', src: confettiFrame17 },
  { id: 'confetti-frame-18', src: confettiFrame18 },
  { id: 'confetti-frame-19', src: confettiFrame19 },
  { id: 'confetti-frame-20', src: confettiFrame20 },
]

export const CONFETTI_FRAME_COUNT = confettiPlaybackFrames.length
